import React, { useState } from 'react';
import { Link } from '../../../env';
const Buy = ({ handleMain }) => {
    const [copiedIndex, setCopiedIndex] = useState(null);

    const clipboard = (data, index) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(data)
                .then(() => {
                    console.log('Text copied to clipboard successfully!');
                    setCopiedIndex(index);
                    setTimeout(() => setCopiedIndex(null), 2000); // reset after 2 seconds
                })
                .catch(err => {
                    console.error('Failed to copy text: ', err);
                });
        } else {
            console.log('Clipboard not supported on this browser.');
        }
    }
    const Crypto = [
        {
            label: 'bc1qm7x9lr6hkadff24e3nm5tjg0ukmlxgm56n20et',
            href: `${Link}assets/crypto_icon/bitcoin.png`,
            name: 'Bitcoin(BTC)',
        },
        {
            label: '0x6b5ac66524f5a79F26976653939e4A3c503e532e',
            href: `${Link}assets/crypto_icon/ethereum.png`,
            name: 'Ethereum(ETH)',
        },
        {
            label: 'TUuee8tcChuZeEmGZ2D85gKQpUTNACKmvo',
            href: `${Link}assets/crypto_icon/trx.png`,
            name: 'Tron(TRX)',
        },
        {
            label: 'TUuee8tcChuZeEmGZ2D85gKQpUTNACKmvo',
            href: `${Link}assets/crypto_icon/usdt.png`,
            name: 'Tether(USDT):TRC-20',
        },
        {
            label: '0x6b5ac66524f5a79F26976653939e4A3c503e532e',
            href: `${Link}assets/crypto_icon/usdt.png`,
            name: 'Tether(USDT):ERC-20',
        }
    ]
    return (
        <div className='w-full relative min-h-screen bg-[#283747] overflow-hidden'>
            <div className='w-full absolute top-0 left-0 z-20'>
                <div className='w-full sticky top-0 left-0 z-20 flex justify-end py-5 px-6'>
                    <a href='/'><img src={`${Link}assets/Icons/return.png`} className='w-[50px] rounded-full p-2 border-2 border-white bg-[#1a5276]' onClick={handleMain} /></a>
                </div>
            </div>
            {/* <div className='w-full absolute top-[90px] left-0 px-6'>
                {
                    Crypto.map((item, index) => {
                        return (<>
                            <div className='w-full flex items-center p-2 mt-5 h-[50px] rounded-xl bg-[rgba(44,83,121,0.6)] border-[1px] border-[rgba(255,255,255,0.5)]'>
                                <div className='w-[20%] flex justify-center items-center  rounded-full '>
                                    <img src={item.href} className={`${index == 2 ? 'w-[50px] h-[50px] rounded-full' : 'w-[30px] h-[30px] rounded-full'}`} />
                                </div>
                                <div onClick={() => clipboard(item.label, index)} className='w-[80%] text-white text-sm flex justify-center items-center poppins-medium cursor-pointer'>
                                    {copiedIndex === index ? 'Copied!' : 'Copy Token'}
                                </div>
                            </div>
                        </>)
                    })
                }
            </div> */}
            <div className='w-full absolute top-[90px] left-0 px-6'>
                <div className='w-full h-full grid grid-cols-2 gap-3'>
                    {
                        Crypto.map((item, index) => {
                            return (<>
                                <div className='w-full rounded-xl bg-[rgba(44,83,121,0.6)] border-[1px] border-[rgba(255,255,255,0.5)]'>
                                    <div className='w-full flex justify-center'>
                                        <img src={item.href} className={`${index == 2 ? 'w-[100px] rounded-full' : 'w-[60px] h-[60px] rounded-full'} my-5`} />
                                    </div>
                                    <div className='w-full text-center poppins-regular text-[12px] text-[rgba(255,255,255,0.8)]'>
                                        <h1 className={`${index == 3 ? 'translate-y-3' : ''}`}>{item.name}</h1>
                                    </div>
                                    <div className='w-full flex justify-center relative py-3'>
                                        <button onClick={() => clipboard(item.label, index)} className={`p-3 ${index == 3 ? 'translate-y-3' : ''} poppins-regular text-[12px] text-[rgba(255,255,255,0.8)] bg-[rgba(30,37,80,0.6)] rounded-xl border-[1px] border-[rgba(255,255,255,0.5)]`}>
                                            {copiedIndex === index ? 'Copied!' : 'Get Wallet Address'}
                                        </button>
                                    </div>
                                </div>
                            </>)
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default Buy;
